import React from "react";
import { Link } from "react-router-dom";

function Home() {
  return (
    <div>
      <div
        className="relative pt-16 pb-32 flex content-center items-center justify-center"
        style={{
          minHeight: "75vh",
        }}
      >
        <div
          className="absolute top-0 w-full h-full bg-center bg-cover"
          style={{
            backgroundImage:
              "url('https://res.cloudinary.com/universitytix/image/upload/v1600942280/VC_h3fg11.png')",
          }}
        >
          <span
            id="blackOverlay"
            className="w-full h-full absolute opacity-75 bg-black"
          ></span>
        </div>
        <div className="container relative mx-auto">
          <div className="items-center flex flex-wrap">
            <div className="w-full lg:w-6/12 px-4 ml-auto mr-auto text-center">
              <div className="pr-12">
                <h1 className="text-white font-semibold text-5xl">
                  PROFESSOR ISAAC ROTIMI AJAYI
                </h1>
                <p className="mt-4 text-lg text-gray-300">
                  B.Sc., M.Sc., Ph.D., FNIP.
                </p>
                <p className="mt-4 text-lg text-gray-300">
                  WELCOME TO MY PORTFOLIO
                </p>
              </div>
            </div>
          </div>
        </div>
        <div
          className="top-auto bottom-0 left-0 right-0 w-full absolute pointer-events-none overflow-hidden"
          style={{ height: "70px", transform: "translateZ(0)" }}
        >
          <svg
            className="absolute bottom-0 overflow-hidden"
            xmlns="http://www.w3.org/2000/svg"
            preserveAspectRatio="none"
            version="1.1"
            viewBox="0 0 2560 100"
            x="0"
            y="0"
          >
            <polygon
              className="text-gray-300 fill-current"
              points="2560 0 2560 100 0 100"
            ></polygon>
          </svg>
        </div>
      </div>

      <section className="pb-20 bg-gray-300 -mt-24">
        <div className="container mx-auto px-4">
          <div className="flex flex-wrap">
            <div className="lg:pt-12 pt-6 w-full md:w-4/12 px-4 text-center">
              <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-8 shadow-lg rounded-lg">
                <div className="px-4 py-5 flex-auto">
                  <div className="text-white p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-5 shadow-lg rounded-full bg-red-400">
                    <i className="fa fa-graduation-cap" aria-hidden="true"></i>
                  </div>
                  <h6 className="text-xl font-semibold">Certifications</h6>
                  <p className="mt-2 mb-4 text-gray-600">
                    Professor AJAYI, Isaac Rotimi has certifications in B.Sc.,
                    M.Sc., Ph.D., FNIP.
                  </p>
                  <Link to="/academics" className="card_links">
                    <i className="fa fa-arrow-right" aria-hidden="true"></i>{" "}
                    View more
                  </Link>
                </div>
              </div>
            </div>

            <div className="w-full md:w-4/12 px-4 text-center">
              <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-8 shadow-lg rounded-lg">
                <div className="px-4 py-5 flex-auto">
                  <div className="text-white p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-5 shadow-lg rounded-full bg-blue-400">
                    <i className="fa fa-book" aria-hidden="true"></i>
                  </div>
                  <h6 className="text-xl font-semibold">Publications</h6>
                  <p className="mt-2 mb-4 text-gray-600">
                    Professor AJAYI, Isaac Rotimi has over 75 publications
                  </p>
                  <Link to="/publications" className="card_links">
                    <i className="fa fa-arrow-right" aria-hidden="true"></i>{" "}
                    View more
                  </Link>
                </div>
              </div>
            </div>

            <div className="pt-6 w-full md:w-4/12 px-4 text-center">
              <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-8 shadow-lg rounded-lg">
                <div className="px-4 py-5 flex-auto">
                  <div className="text-white p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-5 shadow-lg rounded-full bg-green-400">
                    <i className="fa fa-pencil-square-o" aria-hidden="true"></i>
                  </div>
                  <h6 className="text-xl font-semibold">Conferences</h6>
                  <p className="mt-2 mb-4 text-gray-600">
                    Professor AJAYI, Isaac Rotimi has attended a number of
                    international and local conferences
                  </p>
                  <Link to="/conferences" className="card_links">
                    <i className="fa fa-arrow-right" aria-hidden="true"></i>{" "}
                    View more
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <br />
          <br />
          <br />
          <br />

          <div
            className="bottom-auto top-0 left-0 right-0 w-full absolute pointer-events-none overflow-hidden -mt-20"
            style={{ height: "80px", transform: "translateZ(0)" }}
          >
            <svg
              className="absolute bottom-0 overflow-hidden"
              xmlns="http://www.w3.org/2000/svg"
              preserveAspectRatio="none"
              version="1.1"
              viewBox="0 0 2560 100"
              x="0"
              y="0"
            >
              <polygon
                className="text-white fill-current"
                points="2560 0 2560 100 0 100"
              ></polygon>
            </svg>
          </div>

          <div className="container mx-auto px-4">
            <div className="items-center flex flex-wrap">
              <div className="w-full md:w-4/12 ml-auto mr-auto px-4">
                <img
                  alt="..."
                  className="max-w-full rounded-lg shadow-lg"
                  src="https://res.cloudinary.com/universitytix/image/upload/v1600942280/VC_h3fg11.png"
                />
              </div>
              <div className="w-full md:w-5/12 ml-auto mr-auto px-4">
                <div className="md:pr-12">
                  <br />
                  <h3 className="text-3xl font-semibold">
                    Who is Professor AJAYI, Isaac Rotimi
                  </h3>
                  <p className="mt-4 text-sm leading-relaxed text-gray-600">
                    Professor AJAYI, Isaac Rotimi, born on 20th March, 1965,
                    Akure, is a Professor that specializes in Radiation &
                    Health/Physics. He has About 30 years of University teaching
                    experience at undergraduate and postgraduate levels with
                    administrative experience as HOD, Dean of Faculty, Deputy
                    Vice Chancellor and Acting Vice Chancellor and now Vice
                    Chancellor. Dr Ajayi is certified with B.Sc., M.Sc., Ph.D.,
                    and FNIP qualifications. He is a Fellow of the Nigerian Institute of Physics (NIP).
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="pb-20 relative block bg-gray-900">
        <div
          className="bottom-auto top-0 left-0 right-0 w-full absolute pointer-events-none overflow-hidden -mt-20"
          style={{ height: "80px", transform: "translateZ(0)" }}
        >
          <svg
            className="absolute bottom-0 overflow-hidden"
            xmlns="http://www.w3.org/2000/svg"
            preserveAspectRatio="none"
            version="1.1"
            viewBox="0 0 2560 100"
            x="0"
            y="0"
          >
            <polygon
              className="text-gray-900 fill-current"
              points="2560 0 2560 100 0 100"
            ></polygon>
          </svg>
        </div>

        <div className="container mx-auto px-4 lg:pt-24 lg:pb-64">
          <div className="flex flex-wrap text-center justify-center">
            <div className="w-full lg:w-6/12 px-4">
              <h2 className="text-4xl font-semibold text-white">
                Professional category
              </h2>
              <p className="text-lg leading-relaxed mt-4 mb-4 text-gray-500">
                Professor AJAYI, Isaac Rotimi has excelled in a number of
                endeavors. Below are some categorizations of his achievements in
                his academic pursuits.
              </p>
            </div>
          </div>
          <div className="flex flex-wrap mt-12 justify-center">
            <div className="w-full lg:w-3/12 px-4 text-center">
              <div className="text-gray-900 p-3 w-12 h-12 shadow-lg rounded-full bg-white inline-flex items-center justify-center">
                <i className="fa fa-graduation-cap text-xl"></i>
              </div>
              <h6 className="text-xl mt-5 font-semibold text-white">
                Academic Qualifications
              </h6>
              <p className="mt-2 mb-4 text-gray-500">
                Professor Rotimi Ajayi's academic qualifications are listed
                below.
              </p>
              <p className="mt-2 mb-4 text-gray-500">
                <Link to="/academics" className="prof_link">
                  Click here to view
                </Link>
              </p>
            </div>
            <div className="w-full lg:w-3/12 px-4 text-center">
              <div className="text-gray-900 p-3 w-12 h-12 shadow-lg rounded-full bg-white inline-flex items-center justify-center">
                <i className="fa fa-book text-xl"></i>
              </div>
              <h5 className="text-xl mt-5 font-semibold text-white">
                Research Grants Obtained
              </h5>
              <p className="mt-2 mb-4 text-gray-500">
                Here are some of the research grants obtained by Professor
                Rotimi Ajayi.
              </p>
              <p className="mt-2 mb-4 text-gray-500">
                <Link to="/research" className="prof_link">
                  Click here to view
                </Link>
              </p>
            </div>
            <div className="w-full lg:w-3/12 px-4 text-center">
              <div className="text-gray-900 p-3 w-12 h-12 shadow-lg rounded-full bg-white inline-flex items-center justify-center">
                <i className="fa fa-briefcase text-xl"></i>
              </div>
              <h5 className="text-xl mt-5 font-semibold text-white">
                Work experience
              </h5>
              <p className="mt-2 mb-4 text-gray-500">
                Professor Rotimi Ajayi has worked in multiple organizations and
                has gained a lot of experience
              </p>
              <p className="mt-2 mb-4 text-gray-500">
                <Link to="/work-experience" className="prof_link">
                  Click here to view
                </Link>
              </p>
            </div>
          </div>

          <div className="flex flex-wrap mt-12 justify-center">
            <div className="w-full lg:w-3/12 px-4 text-center">
              <div className="text-gray-900 p-3 w-12 h-12 shadow-lg rounded-full bg-white inline-flex items-center justify-center">
                <i className="fas fa-medal text-xl"></i>
              </div>
              <h6 className="text-xl mt-5 font-semibold text-white">
                Community/ Professional service
              </h6>
              <p className="mt-2 mb-4 text-gray-500">
                Professor Rotimi Ajayi has positively graced the world with his
                presence and has performed a number of services professionally
                and in the community.
              </p>
              <p className="mt-2 mb-4 text-gray-500">
                <Link to="/community-service" className="prof_link">
                  Click here to view
                </Link>
              </p>
            </div>
            <div className="w-full lg:w-3/12 px-4 text-center">
              <div className="text-gray-900 p-3 w-12 h-12 shadow-lg rounded-full bg-white inline-flex items-center justify-center">
                <i className="fa fa-globe text-xl"></i>
              </div>
              <h5 className="text-xl mt-5 font-semibold text-white">
                Research/Study Visits
              </h5>
              <p className="mt-2 mb-4 text-gray-500">
                Professor Rotimi Ajayi has travelled to a number of countries to
                further his academic and professional career and to amass
                knowledge from those institutions.
              </p>
              <p className="mt-2 mb-4 text-gray-500">
                <Link to="/visits" className="prof_link">
                  Click here to view
                </Link>
              </p>
            </div>
            <div className="w-full lg:w-3/12 px-4 text-center">
              <div className="text-gray-900 p-3 w-12 h-12 shadow-lg rounded-full bg-white inline-flex items-center justify-center">
                <i className="fa fa-university text-xl"></i>
              </div>
              <h5 className="text-xl mt-5 font-semibold text-white">
                Conferences/workshops
              </h5>
              <p className="mt-2 mb-4 text-gray-500">
                During the course of his career, Professor Rotimi Ajayi has
                attended a number of conferences and workshops and has used
                those mediums to grow academically and professionally.
              </p>
              <p className="mt-2 mb-4 text-gray-500">
                <Link to="/conferences" className="prof_link">
                  Click here to view
                </Link>
              </p>
            </div>
          </div>
        </div>
      </section>

      <footer className="relative bg-gray-300 pt-8 pb-6">
        <div
          className="bottom-auto top-0 left-0 right-0 w-full absolute pointer-events-none overflow-hidden -mt-20"
          style={{ height: "80px", transform: "translateZ(0)" }}
        >
          <svg
            className="absolute bottom-0 overflow-hidden"
            xmlns="http://www.w3.org/2000/svg"
            preserveAspectRatio="none"
            version="1.1"
            viewBox="0 0 2560 100"
            x="0"
            y="0"
          >
            <polygon
              className="text-gray-300 fill-current"
              points="2560 0 2560 100 0 100"
            ></polygon>
          </svg>
        </div>
        <div className="container mx-auto px-4">
          <div className="flex flex-wrap">
            <div className="w-full lg:w-6/12 px-4"> 
              <h4 className="text-3xl font-semibold">
                Want to connect with me?
              </h4>
                          <br />
              <a
                href="mailto:isajayi@yahoo.com?subject = Feedback&body = Message"
                className="email_link"
              >
                <h5 className="text-lg mt-0 mb-2 text-gray-700">
                <i className="flex fa fa-envelope-o"></i>  Send me an email.
                </h5>
              </a>
            <br />
              <a
                href="https://www.linkedin.com/in/isaac-ajayi-9a997980?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_contact_details%3BjNtLvxKCTAa%2F66XldwrHhg%3D%3D"
                className="email_link"
              >
                <h5 className="text-lg mt-0 mb-2 text-gray-700">
                <i className="flex fa fa-linkedin-square"></i> Connect with me on LinkedIn.
                </h5>
              </a>
            </div>
            <br />

            <div className="w-full lg:w-6/12 px-4">
              <div className="flex flex-wrap items-top mb-6">
                <div className="w-full lg:w-4/12 px-4 ml-auto">
                  <span className="block uppercase text-gray-600 text-sm font-semibold mb-2">
                    Useful Links
                  </span>
                  <ul className="list-unstyled">
                    <li>
                      <Link
                        className="text-gray-700 hover:text-gray-900 font-semibold block pb-2 text-sm"
                        to="/academics"
                      >
                        Academics
                      </Link>
                    </li>
                    <li>
                      <Link
                        className="text-gray-700 hover:text-gray-900 font-semibold block pb-2 text-sm"
                        to="/publications"
                      >
                        Publications
                      </Link>
                    </li>
                    <li>
                      <Link
                        className="text-gray-700 hover:text-gray-900 font-semibold block pb-2 text-sm"
                        to="/research"
                      >
                        Research
                      </Link>
                    </li>
                    <li>
                      <Link
                        className="text-gray-700 hover:text-gray-900 font-semibold block pb-2 text-sm"
                        to="/conferences"
                      >
                        Conferences
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className="w-full lg:w-4/12 px-4">
                  <span className="block uppercase text-gray-600 text-sm font-semibold mb-2">
                    Other Links
                  </span>
                  <ul className="list-unstyled">
                    <li>
                      <Link
                        className="text-gray-700 hover:text-gray-900 font-semibold block pb-2 text-sm"
                        to="/contact"
                      >
                        Contact
                      </Link>
                    </li>
                    <li>
                      <Link
                        className="text-gray-700 hover:text-gray-900 font-semibold block pb-2 text-sm"
                        to="/visits"
                      >
                        Visits
                      </Link>
                    </li>
                    <li>
                      <Link
                        className="text-gray-700 hover:text-gray-900 font-semibold block pb-2 text-sm"
                        to="/work-experience"
                      >
                        Experience
                      </Link>
                    </li>
                    <li>
                      <Link
                        className="text-gray-700 hover:text-gray-900 font-semibold block pb-2 text-sm"
                        to="/gallery"
                      >
                        Gallery
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <hr className="my-6 border-gray-400" />
          <div className="flex flex-wrap items-center md:justify-between justify-center">
            <div className="w-full md:w-4/12 px-4 mx-auto text-center">
              <div className="text-sm text-gray-600 font-semibold py-1">
                Copyright © {new Date().getFullYear()} Professor I.R Ajayi
                <br />
                <br />
                <small>
                  This website was designed by{" "}
                  <a
                    href="http://abrahamkolawole.herokuapp.com/"
                    className="ab_link"
                  >
                    Abraham Kolawole
                  </a>
                </small>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
export default Home;
